/**
 * Timestamp provides a serializable version of a timestamp to be used instead of Date
 */
export interface Timestamp {
  /**
   * unixNano contains the number of nano seconds since the start of Unix time
   */
  unixNano: number
}

export const timestampToDate = ({ unixNano }: Timestamp): Date => new Date(unixNano)

export const dateToTimestamp = (d: Date): Timestamp => ({ unixNano: d.getTime() })
